// extracted by mini-css-extract-plugin
module.exports = {"container":"LotPage_container__2yUR9"};